import { keyName, transposeKey } from "../../../theory/key";
import { useDirty, useProject, useServices, useSetlists } from "../../context";

const confirmDiscard = () => window.confirm("You have unsaved changes. Discard them and switch song?");

/** Visible while performing a setlist: where you are, what's next, notes, Prev/Next. */
export function SetlistBar() {
  const { setlists } = useServices();
  const state = useSetlists();
  const song = useProject((p) => p.song);
  const name = useProject((p) => p.name);
  const dirty = useDirty();
  const active = state.active;
  const setlist = active ? state.setlists.find((s) => s.id === active.setlistId) : undefined;
  if (!active || !setlist) return null;
  const entry = setlist.entries[active.index];
  const next = setlist.entries[active.index + 1];
  const nextSong = next ? setlists.song(next.projectId) : undefined;
  return (
    <section className="setlist-bar" aria-label={`Setlist ${setlist.name}`}>
      <button type="button" onClick={() => void setlists.step(-1, confirmDiscard)} disabled={active.index <= 0} aria-label="Previous song">◀</button>
      <div className="setlist-now" aria-live="polite">
        <span className="setlist-pos">{setlist.name} · {active.index + 1}/{setlist.entries.length}</span>
        <strong>{song.title || name}{dirty ? " •" : ""}</strong>
        <span>{keyName(transposeKey(song.key, song.transposeSemitones))} · {song.tempoBpm} BPM</span>
        {entry?.notes && <span className="setlist-notes">{entry.notes}</span>}
        {nextSong && <span className="hint">Next: {nextSong.title || nextSong.name}</span>}
      </div>
      <button type="button" onClick={() => void setlists.step(1, confirmDiscard)} disabled={!next} aria-label="Next song">▶</button>
      <button type="button" onClick={() => setlists.end()}>End</button>
    </section>
  );
}
